"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8269],{

/***/ 28269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ flexible_legal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./components/atoms/prose/index.ts + 1 modules
var prose = __webpack_require__(60864);
;// CONCATENATED MODULE: ./components/atoms/section-legal/SectionLegal.tsx


var VARIANT_MAPS = {
    primary: "text-primary-400",
    secondary: "text-secondary-400",
    alternative: "text-white"
};
var SectionLegal = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, content = param.content, variant = param.variant;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col gap-8 md:flex-col ".concat(className),
        children: content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(prose/* default */.Z, {
            html: content,
            className: "flex flex-col gap-4 ".concat(VARIANT_MAPS[variant])
        }) : null
    });
};
SectionLegal.displayName = "SectionLegal";

;// CONCATENATED MODULE: ./components/atoms/section-legal/index.ts

/* harmony default export */ var section_legal = (SectionLegal);

;// CONCATENATED MODULE: ./components/templates/flexible-legal/FlexibleLegal.tsx


/**
 * FlexibleLegal
 */ var FlexibleLegal = function(param) {
    var backgroundColorBottom = param.backgroundColorBottom, backgroundColorBottomMobile = param.backgroundColorBottomMobile, backgroundColorTop = param.backgroundColorTop, backgroundColorTopMobile = param.backgroundColorTopMobile, content = param.content, cutLevel = param.cutLevel, cutLevelMobile = param.cutLevelMobile, textColor = param.textColor, index = param.index;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
        index: index,
        backgroundColorBottom: backgroundColorBottom,
        backgroundColorTopMobile: backgroundColorTopMobile,
        backgroundColorTop: backgroundColorTop,
        backgroundColorBottomMobile: backgroundColorBottomMobile,
        cutLevel: cutLevel === null ? 50 : cutLevel,
        cutLevelMobile: cutLevelMobile === null ? 50 : cutLevel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(section_legal, {
            variant: textColor,
            content: content
        })
    });
};
FlexibleLegal.displayName = "FlexibleLegal";

;// CONCATENATED MODULE: ./components/templates/flexible-legal/index.ts

/* harmony default export */ var flexible_legal = (FlexibleLegal);


/***/ })

}]);